export const GA4Events = {
  PAGE_VIEW: 'page_view',
  SIGNUP_CTA_CLICKED: 'signup_cta_clicked',
  PRICING_VIEWED: 'pricing_viewed',
  FEATURE_PAGE_VIEWED: 'feature_page_viewed',
  DOCS_SEARCH_USED: 'docs_search_used',
  DOCS_ARTICLE_VIEWED: 'docs_article_viewed',
  DOCS_NAV_CLICKED: 'docs_nav_clicked',
  API_REFERENCE_VIEWED: 'api_reference_viewed',
  WEBHOOK_DOCS_VIEWED: 'webhook_docs_viewed',
  CONTACT_CTA_CLICKED: 'contact_cta_clicked',
  DOCS_CTA_CLICKED: 'docs_cta_clicked',
  WAITLIST_JOIN_STARTED: 'waitlist_join_started',
  WAITLIST_JOIN_COMPLETED: 'waitlist_join_completed',
  LOGIN_VIEWED: 'login_viewed',
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  GUEST_ACCESS_STARTED: 'guest_access_started',
  GUEST_ACCESS_CLAIM_STARTED: 'guest_access_claim_started',
  GUEST_ACCESS_CLAIM_COMPLETED: 'guest_access_claim_completed',
  OCCASION_CREATED: 'occasion_created',
  OCCASION_SETTINGS_UPDATED: 'occasion_settings_updated',
  OCCASION_PUBLISHED: 'occasion_published',
  EVENT_CREATED: 'event_created',
  EVENT_UPDATED: 'event_updated',
  EVENT_PUBLISHED: 'event_published',
  EVENT_VISIBILITY_CHANGED: 'event_visibility_changed',
  ACTOR_CREATED: 'actor_created',
  GUEST_IMPORT_STARTED: 'guest_import_started',
  GUEST_IMPORT_COMPLETED: 'guest_import_completed',
  GUEST_INVITATION_SENT: 'guest_invitation_sent',
  MODULE_INSTALLED: 'module_installed',
  MODULE_CONFIG_UPDATED: 'module_config_updated',
  RSVP_STARTED: 'rsvp_started',
  RSVP_SUBMITTED: 'rsvp_submitted',
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  TIMELINE_ITEM_CREATED: 'timeline_item_created',
  TIMELINE_PUBLISHED: 'timeline_published',
  SEATING_PUBLISHED: 'seating_published',
  PUBLISHING_GENERATED: 'publishing_generated',
  ASSET_UPLOADED: 'asset_uploaded',
  SEARCH_OPENED: 'search_opened',
  SEARCH_RESULT_SELECTED: 'search_result_selected',
  SEARCH_ABANDONED: 'search_abandoned',
  GALLERY_VIEWED: 'gallery_viewed',
  GALLERY_UPLOAD_COMPLETED: 'gallery_upload_completed',
  VENDOR_PORTAL_VIEWED: 'vendor_portal_viewed',
  VENDOR_TASK_COMPLETED: 'vendor_task_completed',
  VENDOR_UPLOAD_COMPLETED: 'vendor_upload_completed',
  GUEST_PORTAL_VIEWED: 'guest_portal_viewed',
  GUEST_SCHEDULE_VIEWED: 'guest_schedule_viewed',
  GUEST_SEATING_VIEWED: 'guest_seating_viewed',
  WEBHOOK_DELIVERY_SUCCEEDED: 'webhook_delivery_succeeded',
  WEBHOOK_DELIVERY_FAILED: 'webhook_delivery_failed',
  EXPORT_COMPLETED: 'export_completed',
  REMINDER_SENT: 'reminder_sent',
} as const;

export type GA4EventName = (typeof GA4Events)[keyof typeof GA4Events];

export const ALLOWED_GA4_PARAMS = new Set([
  'surface',
  'app_section',
  'module_key',
  'locale',
  'principal_type',
  'actor_type',
  'occasion_id',
  'event_id',
  'module_enabled',
  'result',
  'error_code',
  'template_type',
  'job_type',
  'page_type',
  'query_length',
  'result_count',
  'search_resource_type',
]);

export const FORBIDDEN_GA4_PARAMS = new Set([
  'email',
  'phone',
  'name',
  'full_name',
  'first_name',
  'last_name',
  'token',
  'invite_token',
  'guest_token',
  'access_token',
  'note',
  'comment',
  'message',
  'dietary',
  'allergy',
  'address',
  'slug',
  'occasion_title',
  'occasion_name',
  'venue_name',
]);
